import React from 'react';
import { Helmet } from "react-helmet-async";
import { PricingPlans } from '../components/subscription/PricingPlans';
import { SubscriptionStatus } from '../components/subscription/SubscriptionStatus';
import { useAuth } from '../contexts/AuthContext';

const SubscriptionPage: React.FC = () => {
  const { user, loading } = useAuth();
  
  return (
    <>
      <Helmet>
        <title>Manage Subscription | SaunaDip</title>
        <meta name="description" content="Manage your SaunaDip subscription and plans" />
      </Helmet>
      
      <div className="bg-gradient-to-b from-sauna-beige/30 to-white py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-sauna-navy mb-4">
              Choose Your Plan
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Select the perfect plan to grow your sauna business and enhance your online presence
            </p>
          </div>
          
          {user && !loading && (
            <div className="mb-12 max-w-xl mx-auto">
              <SubscriptionStatus />
            </div>
          )}

          <PricingPlans />
          
          <div className="mt-16 max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold text-center mb-8">Frequently Asked Questions</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold text-lg mb-2">What's included in the free trial?</h3>
                <p className="text-gray-600">
                  During your free trial, you'll have access to all features of the selected plan. 
                  Free comes with a 7-day trial, while Premium includes a 14-day trial.
                </p>
              </div>
              
              <div>
                <h3 className="font-semibold text-lg mb-2">Can I upgrade or downgrade anytime?</h3>
                <p className="text-gray-600">
                  Yes, you can upgrade to a higher tier or downgrade to a lower one at any time. 
                  When downgrading, you'll continue to have access to your current plan until the end of your billing cycle.
                </p>
              </div>
              
              <div>
                <h3 className="font-semibold text-lg mb-2">Do you offer refunds?</h3>
                <p className="text-gray-600">
                  We offer a 30-day money-back guarantee if you're not satisfied with your plan. 
                  Contact our support team to process your refund.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionPage;
